import React from "react";
import { IconButton, Tooltip } from "@mui/material";

import { useFlags } from "launchdarkly-react-client-sdk";

import Chip from "components/common/Chip";

import { formatStatusLabel } from "components/Screens/CommonUtils";

import { getChipStatusColor } from "util/utils";

import PeruIcon from "components/Screens/Timeoff/TimeoffAdmin/EmployeeTimeOffDetails/Icons/PeruIcon";
import PakistanIcon from "components/Screens/Timeoff/TimeoffAdmin/EmployeeTimeOffDetails/Icons/PakistanIcon";
import AvatarIcon from "components/Icons/AvatarIcon";

import "./EmployeeInfoTop.scss";

function EmployeeInfoTop(props) {
  const { img, name, jobTitle, country, size, startDate, employeeStatus, hiredDate, managedBy, isScheduled } = props;
  const { anniversaryBasedTimeOff } = useFlags();
  const headerDateLabel = isScheduled ? "Starting on " : "Joined on ";
  // When the employee hasn't started yet, the upstream duration "(1 day)" reflects a negative diff
  // from today — misleading. Strip the trailing "(...)" so only the date is shown.
  const displayedStartDate =
    isScheduled && typeof startDate === "string" ? startDate.replace(/\s*\([^)]*\)\s*$/, "") : startDate;
  const avatarSize = size || {
    width: "65.5px",
    height: "65.5px",
    borderRadius: "50%",
  };
  return (
    <div className="flex start items-center">
      <div className="employee-info-avatar px-1">
        <AvatarIcon shape="circle" size={avatarSize} source={img} />
        {country && (
          <IconButton
            sx={{ position: "absolute", right: "0px", bottom: "-2px", width: "17px", height: "17px", padding: "0px" }}
          >
            {country === "Peru" ? <PeruIcon /> : <PakistanIcon />}
          </IconButton>
        )}
      </div>

      {(name || jobTitle) && (
        <div>
          {name && (
            <Tooltip title={name}>
              <div className="employee-info-name heading-h4-semibold">{name}</div>
            </Tooltip>
          )}

          {jobTitle && <div className="employee-info-job-title heading-h5-medium mb-05">{jobTitle}</div>}
          <div className="employee-info-detail-section">
            {anniversaryBasedTimeOff ? (
              startDate && (
                <div className="flex gap-025 items-center employee-info-detail">
                  <p className="text-headings-secondary para-body-s-medium">{headerDateLabel}</p>
                  <p className="employee-info-date para-body-s-medium mr-025">{`${displayedStartDate}`}</p>
                  {employeeStatus && (
                    <Chip
                      label={formatStatusLabel(employeeStatus)}
                      color={getChipStatusColor(employeeStatus)}
                      size="small"
                      variant="filled"
                    />
                  )}
                </div>
              )
            ) : (
              <>
                {hiredDate && (
                  <div className="flex gap-025 employee-info-detail">
                    <p className="text-headings-secondary para-body-s-regular">Hired on </p>
                    <p className="employee-info-date para-body-s-medium">{`${hiredDate}`}</p>
                  </div>
                )}
                {managedBy && (
                  <div className="flex gap-025 employee-info-detail">
                    <p className="text-headings-secondary para-body-s-regular">Managed by </p>
                    <p className="employee-info-managed-by para-body-s-medium">{`${managedBy}`}</p>
                  </div>
                )}
              </>
            )}
          </div>
        </div>
      )}
    </div>
  );
}

export default EmployeeInfoTop;
